import styled from 'styled-components';
import { COLORS } from '../../../constants/style/color';
import { rem } from '../../../utils/style';

export const DisbursementConfigContainer = styled.div`
  background: ${COLORS.White};
  border: ${rem(1)} solid ${COLORS.CulturedWhite};
  border-radius: ${rem(6)};
  padding: ${rem(18)} ${rem(18)} ${rem(32)} ${rem(18)};
  margin-bottom: ${rem(62)};
`;
